import { render } from "./sharePlanCard.vue?vue&type=template&id=13923511"
import script from "./sharePlanCard.vue?vue&type=script&lang=js"
export * from "./sharePlanCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__